import React from 'react';
import { ContactUs } from '../components/contact-us.component';
import Header from '../components/header.component';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import { useSelector } from 'react-redux';
import '../scss/main.scss';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
export const ContactUsPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
  const canonicalUrl = isEnglish
    ? `https://www.invozio.com/contact-us?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/kontakta-oss?lang=${LOCALES.SV_SE}`;


  const schemaMarkup = getSchemaMarkup("kontakta-oss");
  return (
    <div className="contact-us-page">
      <Header />
      <SEOMetadataComponent
        title={t('Contact Us')}
        // description={t('FEATURES_MAIN_DESCRIPTION')}
        canonicalUrl={canonicalUrl}
        noindex={false}
        robots="index, follow"
        schemaMarkup={schemaMarkup}
      />
      <SectionHeader
        titleKey={t('Contact Us')}
        subtitleKey={t('CONTACT_US_SUBTITLE')}
        className="invozio-news-section"
        titleClassName="main-title"
        subtitleClassName="sub-title"
        alignment="center"
      />
      <ContactUs />
      <div className="bg-footer">
        <AccountAccess />
        <Footer />
      </div>
    </div>
  );
};

export default ContactUsPage;
